import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
const WithoutAuthRoute = () => {
    const token = useSelector(state => state?.userData?.access_token)
    return (
        <>
            {!token ? <Outlet /> : <Navigate to='/select-business' />}
        </>
    )
}
export default WithoutAuthRoute;